$(document).ready(function () {

$(".custom-product-option li").on("click", function () {
    const variantInput = $('.product-variant-id');
    let varSrc = $(this).attr('variant-image');
    let varPrice = $(this).attr('variant-price').replace('Rs. ','₹');
    const cardInner = $(this).closest('.card__content').prev();
    let cstmImage = cardInner.find('.custom-img');

     const selectedId = $(this).attr('variant-id');
    $(this).parents('.card-wrapper').find('.product-variant-id').val(selectedId);
    console.log('selectedId', selectedId)
    const swatchContainer = $(this).closest('.custom-product-option');
      swatchContainer.find('.variant-swatch').removeClass('active');
      $(this).addClass('active');
     // if (variantInput.length && selectedId) {
     //    variantInput.val(selectedId);
     //  }
    const cardPrice = $(this).parent().parent().prev().find('.price-item.price-item--sale.price-item--last');
    console.log($(this).parent().parent().prev().find('.price-item.price-item--sale.price-item--last'),'heeheheeh')
    cardInner.find(".media.media--transparent.media--hover-effect").css("display", "none");
    cstmImage.css('display','block');
    cstmImage.attr('src',varSrc);
    cardPrice.text(`${varPrice}`)
  });


  
$('body').on('click', '.simliar_product_varaint', function() {   
    var alt_this = $(this).attr('alt').trim();
    $('.variant_one label').each(function(){   
    var inputValue = $(this).attr('title').trim();
    console.log('inputValue', inputValue);
    if (inputValue === alt_this) {
    $(this).trigger('click'); 
    }
    });
    $('.simliar_product_varaint').removeClass('active');
    $(this).addClass('active');
    });
});